export enum EntityStatuses {
  Active = "ACTIVE",
  Inactive = "INACTIVE",
  Pending = "PENDING",
}
